import './jquery-share.js';

let pvbt = {}
window.pvbt = pvbt;

jQuery(function($) {
	
	pvbt = {

		tags: [],
		search: "",

		init: function(){
			this.swipers();
			this.colorSwitch();
			this.groupToggle();
			this.orgFilters();
			this.search();
			this.share();
			this.cookie();
		},

		swipers: function() {
			if (typeof swipers !== "undefined") {
				const sliders = swipers || [];
				sliders.forEach(function(element) {
					// var swiper = new Swiper(element.selector, element.options)
				});
			}
		},
		
		colorSwitch: function() {
			const defaultMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light";
			let colorMode = localStorage.getItem("colorMode") || defaultMode;
			
			$(".navbar-switch").on("click", function(e) {
				e.preventDefault();
				colorMode = (colorMode === "light" || $("body").hasClass("light-mode")) ? "dark" : "light";
				$("body").toggleClass("light-mode", colorMode === "light").toggleClass("dark-mode", colorMode === "dark");
				localStorage.setItem("colorMode", colorMode);
			});
		},

		cookie: function() {
			const cookieNoticeClosed = localStorage.getItem("cookieNoticeClosed") || false;

			if(!cookieNoticeClosed) {

				$(".cookie-notice").show().find(".cookie-notice__close").on("click", function(e) {
					e.preventDefault();
					localStorage.setItem("cookieNoticeClosed", true);
					$(".cookie-notice").hide();
				});

			}

		},
		
		groupToggle: function() {
			$(".toggle-group a").on("click", function(e) {
				e.preventDefault();
				const target = $(this).attr("href");
				$(this).parent().addClass("active").siblings().removeClass("active");
				$(target).show().siblings(".wp-block-group").hide();
			});
			
			const hash = window.location.hash;
			const $toggleGroupLinks = $(".toggle-group a");
			
			if (hash && $toggleGroupLinks.filter(`[href="${hash}"]`).length) {
				$toggleGroupLinks.filter(`[href="${hash}"]`).trigger("click");
			} else {
				$toggleGroupLinks.eq(0).trigger("click");
			}
		},
		
		orgFilters: function() {

			$(".organisation__reset").on('click', (e)=>{
				e.preventDefault();
				$("#organisationSearch").val("");
				pvbt.search = "";
				pvbt.tags = [];
				pvbt.updateFilters();
			})
			$(".organisation__tag").on("click", function(e) {
				e.preventDefault();
				$(".organisation__dropdown-item[href='"+$(this).attr("href")+"']:not(.active)").trigger("click");
			});
			$(".organisation__dropdown-item").on("click", function(e) {
				e.preventDefault();
				$(this).toggleClass("active");
				const tag = $(this).attr("href").replace("#", "");
				pvbt.tags = pvbt.tags.includes(tag) ? pvbt.tags.filter(item => item !== tag) : [...pvbt.tags, tag];
				pvbt.updateFilters();
			});
			$(".organisation__active-tags").on('click','.organisation__tag--active',function(e){
				e.preventDefault();
				pvbt.tags = pvbt.tags.filter((item, index) => index !== $(this).data("tag"));
				pvbt.updateFilters();
			})
			$("#organisationSearch").on("input",function(){
				pvbt.search = $(this).val();
				pvbt.updateFilters();

			})

			// show all orgs
			$(".organisation__expand a").on('click',function(e){
				e.preventDefault();
				$(this).parents(".organisation__items").addClass("organisation__items--expanded");
				$(this).remove();
				pvbt.updateFilters();
			})

			pvbt.updateFilters();

		},
		
		search: function(){
			$(".navbar-search").on("click",function(e){
				e.preventDefault();
				$(".navbar").toggleClass("searching");
				jQuery('input[name="s"]').focus();
			});
		},
		
		updateFilters: function() {
			
			// filter by search
			const minLimit = 8;
			let foundCount = 0;


			$(".organisation__item").show();

			// filter by tags (after search)
			if(pvbt.tags.length == 0){
				$(".organisation__dropdown-item").removeClass("active");
				$(".organisation__active-tags").html("");
			}else{
				const tags = pvbt.tags.map(tag => `.tag-${tag}`).join(',');
				$(".organisation__item").not(`:has(${tags})`).hide();
				$(".organisation__active-tags").html("");
				pvbt.tags.forEach((tag, index) => {
					$('.organisation__active-tags').append($(`<span class="organisation__tag--active" data-tag="${index}">`).text(tag));
				});
			}

			$(".organisation__item").each(function(i){
				if(pvbt.search.length > 0 && $(this).text().toLowerCase().indexOf(pvbt.search.toLowerCase()) === -1){
					$(this).hide();
				} else {
					if($(this).is(":visible")) foundCount++;
					if( ! $(".organisation__items").hasClass("organisation__items--expanded") && foundCount > minLimit) 
						$(this).hide();
				}
			})

			// hide showAll if < 8
			foundCount <= minLimit
				? $(".organisation__expand").hide()
				: $(".organisation__expand").show();
			
			
		},
		share: function() {
			$("[data-share]").share();
		}
	};
	
	pvbt.init();	

})
